/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../../services/toast';
export default {
  name: 'sa-organization-list',
  components: {},
  props: [],
  data () {
    return {
      saOrgList:{},
      nextStep:'',
      saOrgListResults:[],
      loadmoreData: {},
      submitted:false,
      DeleteId:'',
      checkDataTaskModal:false
    }
  },
  computed: {
  ...mapGetters([
    'SaOrgListDataGetters'
  ]),
  getOrgListDetailsFun(){
    return this.saOrgList = this.$store.getters.SaOrgListDataGetters.data
  },
  SetIntialStatus() {
    if (this.saOrgList != undefined) {
      this.saOrgListResults = this.saOrgList.users
    }
  }
  },
  mounted () {
    this.getOrgListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('getSaOrgListFun').then((res) => {
        this.saOrgList = this.$store.getters.SaOrgListDataGetters.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("task_modal_actv");
      this.checkDataTaskModal = true
      this.DeleteId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeSaOrgUserFun', {
        id: this.DeleteId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("task_modal_actv");
          this.getRemoveListAgain()
          this.checkDataTaskModal = false
          this.DeleteId = ''
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("task_modal_actv");
      this.checkDataTaskModal = false
      this.taskDeleteId = ''
    }
  },
  watch:{
    getOrgListDetailsFun(){
      return this.saOrgList = this.$store.getters.SaOrgListDataGetters.data
    },
    SetIntialStatus() {
      if (this.saOrgList != undefined) {
        this.saOrgListResults = this.saOrgList.results
      }
    }
  }
}


